// extracted by mini-css-extract-plugin
export default {"container":"LearningTimeLimitView_container__JFyE3","ring":"LearningTimeLimitView_ring__2keko","countText":"LearningTimeLimitView_countText__y922K"};